import React from 'react';
import { Modal } from 'dyl-components';
import { Button, Breadcrumb } from 'semantic-ui-react';
import RefreshTextCampaignForm from 'shared/forms/RefreshTextCampaignForm';

import './RefreshModal.scss';

const RefreshTextCampaignModal = ({
    open,
    onClose,
    ...otherProps
}) => (
        <Modal open={open} onClose={onClose} animated={false}>
            <Modal.Header>
                <div>
                    Refresh Campaign
                </div>
                <Breadcrumb size='huge' className="Breadcrumb">
                    <Breadcrumb.Section className="BreadcrumbSection">Step 1</Breadcrumb.Section>
                    <Breadcrumb.Divider icon='right chevron' />
                    <Breadcrumb.Section>Step 2</Breadcrumb.Section>
                </Breadcrumb>
            </Modal.Header>
            <Modal.Content>
                <RefreshTextCampaignForm {...otherProps} />
            </Modal.Content>
            <Modal.Actions>
                <Button primary>Filter</Button>
            </Modal.Actions>
        </Modal>
    )

class RefreshTextCampaignModalContainer extends React.Component {

    render() {
        return (
            <RefreshTextCampaignModal
                {...this.props}
            />
        )
    }
}


export default RefreshTextCampaignModalContainer;
